import { createIdentifier } from '@toeverything/infra';

export interface NativePaywallProvider {
  /** Opens the store paywall; the store lists the offered plans. */
  showPaywall(): Promise<void>;
}

export const NativePaywallProvider = createIdentifier<NativePaywallProvider>(
  'NativePaywallProvider'
);
